import HttpService from "../base/HttpService";
export default class GenerationService extends HttpService {
  static api = process.env.VUE_APP_BASE_API;

  getDataGeneration(param) {
    const api = this.api + "generation/summary";
    return this.get(param, api);
  }

  getDataGenerationSystem(param) {
    const api = this.api + "generation/system";
    return this.get(param, api);
  }

  getDataGenerationRegion(param) {
    const api = this.api + "generation/region";
    return this.get(param, api);
  }

  getDataGenerationRegionDetail(param) {
    const api = this.api + "generation/region-detail";
    return this.get(param, api);
  }

  getDataGenerationPlant(param) {
    const api = this.api + "generation/plant";
    return this.get(param, api);
  }

  getDataGenerationFuelMix() {
    const api = this.api + "generation/full-mix";
    return this.get("", api);
  }

  getDataGenerationSystemBck(param) {
    const api = this.api + "generation-system";
    return this.get(param, api);
  }

  getDataGenerationMap(param) {
    const api = this.api + "generation-map";
    return this.get(param, api);
  }

  getDataGenerationAdditional(param) {
    const api = this.api + "generation/additional";
    return this.get(param, api);
  }

  getDataGenerationAdditionalDetail(param) {
    const api = this.api + "generation/detail-additional";
    return this.get(param, api);
  }

  getDetailEffor(param) {
    const api = this.api + "generation/detail-efor";
    return this.get(param, api);
  }

  getRefStage() {
    const api = this.api + "ref/stage";
    return this.get('', api);
  }

  getDataKesiapan(param){
    const api = this.api + "generation/detail-daya";
    return this.get(param, api);
  }
}
